// Home.js
import React from 'react';
import HomeBackgroundImage from './/assets/home_bg.jpg';


function Home({ language, content }) {
  return (
    <section id="home" className="home-section">
      <div className="home-background-image-container">
        {/* Replace with your actual image */}
        <img src={HomeBackgroundImage} alt="Background" className="home-background-image" />
      </div>
      {/* You might want to add some text content here on top of everything if needed */}
      {/* For example:
      <div style={{position: 'relative', zIndex: 4, color: 'white', textAlign: 'center'}}>
        <h2>Welcome</h2>
      </div>
      */}
    </section>
  );
}

export default Home;